<p-dialog
  [header]="'call-file-dialog.modal-title' | translate"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  (onHide)="closeDialog()"
  [style]="{ width: '70rem', 'max-height': '85vh', 'overflow-y': 'auto' }"
  [focusOnShow]="false"
>
  <div class="modal-body">
    <div class="button-group">
      <button
        pButton
        *ngFor="let button of buttons"
        [label]="button.label | translate"
        class="custom-btn"
        [ngClass]="{ selected: selectedId === button.id }"
        (click)="selectButton(button.id)"
      ></button>
    </div>

    <div class="mb-4 d-flex justify-content-end">
      <div class="d-flex align-items-center">
        <button
          data-bs-toggle="offcanvas"
          data-bs-target="#addFileToCall"
          type="button"
          class="btn btn-primary ms-auto"
          (click)="addFile()"
        >
          {{ "call-file-dialog.add-file" | translate }}
        </button>
      </div>
    </div>

    <div class="card">
      <div class="files-card-header">
        <div class="row mb-2">
          <div class="col-xl-3">
            <h5>{{ "call-file-dialog.file-name" | translate }}</h5>
          </div>
          <div class="col-xl-3">
            <h5>{{ "call-file-dialog.file-description" | translate }}</h5>
          </div>
          <div class="col-xl-2">
            <h5>{{ "call-file-dialog.file-added-user" | translate }}</h5>
          </div>
          <div class="col-xl-2">
            <h5>{{ "call-file-dialog.file-created-date" | translate }}</h5>
          </div>
          <div class="col-xl-2"></div>
        </div>
      </div>
      <div
        class="row mb-3"
        style="padding-left: 1%"
        *ngFor="let file of filteredFiles; let i = index"
      >
        <div class="col-xl-3">
          <p>{{ file?.name }}</p>
        </div>
        <div class="col-xl-3">
          <p>{{ file?.name }}</p>
        </div>
        <div class="col-xl-2">
          <p>{{ file?.name }}</p>
        </div>
        <div class="col-xl-2">
          <p>{{ file?.name }}</p>
        </div>
        <div class="col-xl-2">
          <button
            class="btn btn-warning btn-sm me-2"
            (click)="downloadFile(file)"
            *ngIf="file?.id"
          >
            <i class="fa fa-download"></i>
          </button>
          <button class="btn btn-danger btn-sm" (click)="deleteFile(file)">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex align-items-center">
      <div>
        <button class="btn btn-danger me-2" (click)="cancelDialog()">
          {{ "common.cancel" | translate }}
        </button>
        <button class="btn btn-success" (click)="contiune()">
          {{ "call-file-dialog.contiune" | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<app-upload-file-upload-dialog
  #callUploadFileDialog
  (fileAdded)="onSaveFile($event)"
  [moduleName]="'call'"
></app-upload-file-upload-dialog>
